import React from 'react'
import { useAppSeo } from '@core/Utils/hooks/useAppSeo'
import { GoodThings } from './Components/GoodThings'
import { CurrentGoodThings, CurrentGoodThingsKey } from './data-access/giddyUpGoodThings'

export const GoodThingsPage: React.FC = () => {
  useAppSeo({
    title: 'Good Things | TABtouch',
    description: 'Explore good things content and betting information with TABtouch.',
  })
  React.useEffect(() => {
    CurrentGoodThings.getPromise(CurrentGoodThingsKey)
  }, [])

  return <GoodThings />
}
